import GenericBoostModal from "./generic-boost-modal";
import {
    format_currency,
    resetToBasePrice,
    disableCouponField,
    enableCouponField,
    getAvailablePromotionCode,
    removeDiscountLabel,
    userHasPromotionSelected,
    resetCouponFields,
    disableCheckoutButton,
    enableCheckoutButton,
    handleCheckoutButton,
    BASE_PRICE_ATTR,
    APPLIED_COUPON_FIELD_INPUT,
    PROMOTION_RADIO_CHECKED_SELECTOR,
    PROMOTION_RADIO_SELECTOR,
    APPLY_COUPON_JS,
} from "./cart_summary_helpers";

import {applyPromotion, clearCouponFromCart} from "./submitCoupon";

const PROMOTION_NOT_SELECTED = ".promotion-option-not-selected--js";
const PROMOTION_SELECTED = ".promotion-option-selected--js";
const PROMOTION_SELECTED_CLASS = "cart-summary-upsell__option-container-selected";

function togglePromotion() {
    if (userHasPromotionSelected()) {
        disableCouponField();
        $(PROMOTION_NOT_SELECTED).removeClass(PROMOTION_SELECTED_CLASS);
        $(PROMOTION_SELECTED).addClass(PROMOTION_SELECTED_CLASS);

        applyPromotion(getAvailablePromotionCode()).then(res => {
            if (!userHasPromotionSelected()) {
                togglePromotion()

                resetCouponFields();
                return;
            }
        });
    }
    else {
        resetCouponFields();
        clearCouponFromCart();
        removeDiscountLabel();
        resetToBasePrice();
        enableCouponField();

        $(PROMOTION_NOT_SELECTED).addClass(PROMOTION_SELECTED_CLASS);
        $(PROMOTION_SELECTED).removeClass(PROMOTION_SELECTED_CLASS);
    }
}

$(document).ready(() => {
    // listen for toggling of promotion.
    $(PROMOTION_RADIO_SELECTOR).on(
        'change',
        (e) => {
            togglePromotion();
        }
    );
});

